import { isCrudRouteEnabledForTenant } from '@pelicargo/tenants';

import { trpc } from '../../config/trpc';

/** The booking confirmation behind the most recent apply on a quote; null when nothing was ever applied to it. */
export const useLatestAppliedDraft = (quoteId: number | undefined) => {
  // The procedure is AI Inbox only: on a tenant without it, every quote would ask and be refused.
  const isEnabled = !!quoteId && isCrudRouteEnabledForTenant('/ai-inbox');
  const { data } = trpc.getLatestAppliedDraftByQuote.useQuery({ quoteId: quoteId as number }, { enabled: isEnabled });
  return data;
};
